module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('x-header', {
    staticClass: "header-define",
    attrs: {
      "title": "风险测评",
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.$_evaluation_back
    },
    slot: "left"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back",
    attrs: {
      "type": "ios-arrow-back",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "evaluation"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "evaluation-main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stepCurrent),
      expression: "stepCurrent"
    }],
    staticClass: "propress-line"
  }, [_c('my-step', {
    attrs: {
      "step": _vm.stepCurrent,
      "totalstep": _vm.stepTotal
    }
  })], 1), _vm._v(" "), _c('card', {
    staticStyle: {
      "position": "absolute",
      "left": "0",
      "top": "45px",
      "right": "0",
      "bottom": "70px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "card-padding",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "height": "1px",
      "background-color": "#ebecf5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "evaluation-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.params.userName))]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v("测评时间：" + _vm._s(_vm.time))])]), _vm._v(" "), _c('div', {
    staticClass: "tip-info"
  }, [_vm._v("\n            " + _vm._s(_vm.question.questionHead) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "evaluation-btn"
  }, [_c('submit-button', {
    on: {
      "click": _vm.$_evaluation_test
    }
  }, [_vm._v("开始测评")])], 1)])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-023cb156"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Evaluation/One.vue
// module id = 1012
// module chunks = 1